import { Tag, Tooltip } from 'antd'

const SectorActsDisplayer = ({ actTypes }) => {
  return (
    <div>
      {actTypes.map((at, index) => (
        <Tooltip key={at.acronym + index} title={at.name}>
          <Tag> {at.acronym} </Tag>
        </Tooltip>
      ))}
    </div>
  )
}

export default SectorActsDisplayer
